import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './button.scss';

export const SKINS = {
  DEFAULT: 'default',
  TRANSPARENT: 'transparent',
};

const Button = ({ children, onClick, skin = SKINS.DEFAULT, className }) => (
  <button
    className={classNames(styles.button, styles[`skin-${skin}`], className)}
    onClick={onClick}
  >
    {children}
  </button>
);

Button.propTypes = {
  skin: PropTypes.oneOf(_.values(SKINS)),
  children: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default Button;
